import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Badge } from '../ui/badge';
import { Video, ExternalLink } from 'lucide-react';
import { ASS_MAP } from './constants';

export const VideoEvidencePanel = ({ allEvidence, tagsById }) => (
  <Card data-testid="evidence-tab">
    <CardHeader className="pb-2"><CardTitle className="text-base">Video Evidence ({allEvidence.length})</CardTitle></CardHeader>
    <CardContent className="space-y-2">
      {allEvidence.length === 0 && (
        <p className="text-sm text-gray-400 py-8 text-center" data-testid="evidence-empty">
          No evidence linked. Attach Veo timestamps to observations in the Analysis tab.
        </p>
      )}
      {allEvidence.map((e, i) => {
        const am = ASS_MAP[e._obs.assessment] || ASS_MAP.neutral;
        const link = e.clip_url || e.url;
        return (
          <div key={`${e.id}-${i}`} className="border rounded-lg p-3 flex items-center justify-between gap-3" data-testid={`evidence-item-${e.id}`}>
            <div className="min-w-0">
              <div className="flex items-center gap-2 text-sm font-medium">
                <Video className="w-3.5 h-3.5 text-sky-600" />
                {e.source} · {e.timestamp_display || '—'}
                <Badge className={`${am.cls} text-xs`}>{am.label}</Badge>
              </div>
              <p className="text-xs text-gray-500 truncate">
                {e.label ? `${e.label} · ` : ''}{e._obs.category}
                {(e._obs.development_tag_ids || []).length ? ` · ${(e._obs.development_tag_ids || []).map(id => tagsById[id]?.label).filter(Boolean).join(', ')}` : ''}
              </p>
            </div>
            {link && (
              <a href={link} target="_blank" rel="noopener noreferrer"
                 className="text-sky-600 hover:underline text-sm flex items-center gap-1 shrink-0" data-testid={`evidence-open-${e.id}`}>
                <ExternalLink className="w-3.5 h-3.5" /> Open in Veo
              </a>
            )}
          </div>
        );
      })}
    </CardContent>
  </Card>
);
